import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getIssueApiUrlForComment } from '../utils.tsx';

export const deleteCommentFromJira = (issueIdOrKey: string, commentId: string): Promise<void> =>
	performDeleteRequest(getIssueApiUrlForComment(issueIdOrKey, commentId));
